import Resizer from 'react-image-file-resizer';

export interface IResizeImage {
  file: Blob;
  maxWidth: number;
  maxHeight: number;
  compressFormat: 'JPEG' | 'PNG' | 'WEBP';
  outputType?: 'base64' | 'blob' | 'file';
  minWidth?: number;
  minHeight?: number;
}

export const resizeImage = (options: IResizeImage): Promise<string | Blob | File | ProgressEvent<FileReader>> =>
  new Promise((resolve, reject) => {
    try {
      Resizer.imageFileResizer(
        options.file,
        options.maxWidth,
        options.maxHeight,
        options.compressFormat,
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        options.outputType,
        options.minWidth,
        options.minHeight
      );
    } catch (e) {
      reject(e);
    }
  });
